import {
  bakeryDough,
  bakeryFilling,
  beverages,
  cereals,
  confectionary,
  convenience,
  dairy,
  desserts,
  fruitJam,
  meatFish,
  soupsSaucesSeasonings,
} from '../dependencies/FoodNutrition';
import { TaxonomyKeyRepresentation } from '../StepFormulationAttributes/types';

// This data is mostly duplicated in fieldDependencies.ts:processingCapabilitiesFields, but
// we want to explicitly differentiate between fields to display and fields that are mandatory.
export const processingCapabilitiesFields = [
  'bakeStability',
  'bakingTime',
  'bakingTemperature',
  'mixingStepDetails',
  'processingCapabilitiesPackagingDetails',
  'productPh',
  'brix',
  'fillingTime',
  'fillingTemperature',
  'foodSafetyDetails',
  'processingHotCold',
  'homogenisation',
  'otherProcessingCapabilities',
] as const;
export type ProcessingCapabilitiesFields = typeof processingCapabilitiesFields[number];

export const processingCapabilityFieldDependencies: {
  [key in ProcessingCapabilitiesFields]: TaxonomyKeyRepresentation[];
} = {
  bakeStability: [...bakeryFilling, ...fruitJam, ...soupsSaucesSeasonings],
  bakingTime: [
    ...bakeryDough,
    ...bakeryFilling,
    ...cereals,
    ...confectionary,
    ...convenience,
    ...dairy,
    ...desserts,
    ...fruitJam,
    ...meatFish,
    ...soupsSaucesSeasonings,
  ],
  bakingTemperature: [
    ...bakeryDough,
    ...bakeryFilling,
    ...cereals,
    ...confectionary,
    ...convenience,
    ...dairy,
    ...desserts,
    ...fruitJam,
    ...meatFish,
    ...soupsSaucesSeasonings,
  ],
  mixingStepDetails: [
    ...bakeryDough,
    ...bakeryFilling,
    ...beverages,
    ...cereals,
    ...confectionary,
    ...convenience,
    ...dairy,
    ...desserts,
    ...fruitJam,
    ...meatFish,
    ...soupsSaucesSeasonings,
  ],
  processingCapabilitiesPackagingDetails: [
    ...bakeryDough,
    ...beverages,
    ...cereals,
    ...fruitJam,
  ],
  productPh: [
    ...bakeryFilling,
    ...beverages,
    ...confectionary,
    ...convenience,
    ...dairy,
    ...desserts,
    ...fruitJam,
    ...meatFish,
    ...soupsSaucesSeasonings,
  ],
  brix: [...bakeryFilling, ...confectionary, ...fruitJam],
  fillingTime: [
    ...fruitJam,
    ...bakeryFilling,
    ...confectionary,
    ...dairy,
    ...desserts,
  ],
  fillingTemperature: [
    ...fruitJam,
    ...bakeryFilling,
    ...confectionary,
    ...dairy,
    ...desserts,
  ],
  foodSafetyDetails: [
    ...beverages,
    ...convenience,
    ...dairy,
    ...desserts,
    ...meatFish,
    ...soupsSaucesSeasonings,
  ],
  processingHotCold: [...beverages],
  homogenisation: [...dairy, ...desserts],
  otherProcessingCapabilities: [],
};
